<template>
  <section class="mt-24 mb-48">
    <div class="flex justify-between gap-8 mb-24">
      <div>
        <h2 class="text-h4 mb-8">Meet {{ sitterDisplayName }}</h2>
        <p class="text-body">{{ adventure.sitterYearsExperience }} years paid experience</p>
        <StarRating v-if="showRating" :count="totalRatings" :average="avgRating" :aria-label="ratingLabel" />
      </div>
      <Avatar :imageUrl="adventure.sitterImageUrl" :name="sitterDisplayName" size="xl" />
    </div>
    <div class="flex gap-16">
      <Button :to="sitterProfileUrl" value="View Profile" variant="outlined" size="medium" class="w-full" />
      <Button value="Contact" variant="outlined" size="medium" class="w-full" @click="$emit('clickContact')" />
    </div>
  </section>
</template>

<script lang="ts">
import StarRating from '../../../components/star_rating/StarRating.vue';
import Avatar from '../../../components/avatar/Avatar.vue';
import Button from '../../../components/button/Button.vue';
import { SITTER_RATING_QUERY } from '@/graphql/adventures/queries';
import getProviderProfileUrl from '@/helpers/providerProfileUrl';

export default {
  name: 'SitterContactPrompt',
  components: { StarRating, Avatar, Button },
  props: {
    adventure: {
      default: () => {},
      type: Object,
    },
  },
  data(): any {
    return {
      avgRating: undefined,
      totalRatings: undefined,
      showRating: false,
    };
  },
  computed: {
    sitterDisplayName(): string {
      return `${this.adventure.sitterFirstName} ${this.adventure.sitterLastInitial}.`;
    },
    sitterProfileUrl(): string {
      return getProviderProfileUrl(this.adventure.sitterUuid, 'babysitter') || '';
    },
    ratingLabel(): string {
      return `Rating: ${this.avgRating} out of 5 stars. Total Reviews: ${this.totalRatings}`;
    },
  },
  mounted() {
    this.$apollo
      .query({
        query: SITTER_RATING_QUERY,
        variables: { ids: [this.adventure.sitterUuid] },
      })
      .then((payload: any) => {
        if (payload.data.sitters) {
          const { avgRating, totalRatings } = payload.data.sitters[0];
          this.showRating = true;
          this.avgRating = avgRating || 0;
          this.totalRatings = totalRatings || 0;
        }
      })
      .catch((error) => {
        this.showRating = false;
        console.error(error);
      });
  },
};
</script>
